<template>
  <section class="page-error-code-test">
    <h2 class="page-title">错误码排查</h2>
    <div class="page-content">
      <section class="page-content__left">
        <Form
          ref="formData"
          :model="formData"
          :rules="ruleValidate"
          :label-width="80"
        >
          <FormItem label="API名称" prop="apiCode">
            <Input v-model="formData.apiCode" placeholder="请输入API名称" />
          </FormItem>
          <FormItem label="查询方式" prop="type">
            <RadioGroup v-model="formData.type">
              <Radio label="0">错误码查询</Radio>
              <Radio label="1">按完整错误查询</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            label="错误码"
            prop="errorCode"
            v-if="formData.type === '0'"
          >
            <Input v-model="formData.errorCode" placeholder="请输入" />
          </FormItem>
          <FormItem label="错误详情" prop="errorRemark" v-else>
            <Input
              type="textarea"
              :rows="4"
              v-model="formData.errorRemark"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem>
            <Button
              class="handle-button"
              type="primary"
              @click="handleSubmit('formData')"
              >提交测试</Button
            >
          </FormItem>
        </Form>
      </section>
      <section class="page-content__right">
        <div class="req-item">
          <header>查询结果</header>
          <div class="req-item__content" v-loading="loading">
            <ul class="error-list" v-if="errorList.length">
              <li
                class="error-list__item"
                v-for="item in errorList"
                :key="item.id"
              >
                <div>
                  <label>错误码：</label><span>{{ item.errorCode }}</span>
                </div>
                <div>
                  <label>错误描述：</label><span>{{ item.errorRemark }}</span>
                </div>
                <div>
                  <label>解决方案：</label><span>{{ item.errorAcmark }}</span>
                </div>
              </li>
            </ul>
            <div v-else>暂无数据</div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      formData: {
        apiCode: "",
        type: "0",
        errorRemark: "",
        errorCode: ""
      },
      ruleValidate: {
        apiCode: [
          {
            required: true,
            message: "请输入API名称",
            trigger: "blur"
          }
        ],
        errorRemark: [
          {
            required: true,
            message: "请输入报错信息",
            trigger: "blur"
          }
        ]
        // errorCode: [
        //   {
        //     required: true,
        //     message: "请输入错误码",
        //     trigger: "blur"
        //   }
        // ]
      }
    };
  },
  computed: {
    ...mapState({
      errorList: state => state.errorCode.errorList
    })
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    ...mapActions({
      queryError: "errorCode/queryError"
    }),
    async handelSave() {
      let { apiCode, type, errorRemark, errorCode } = this.formData;
      this.loading = true;

      await this.queryError(
        type === "0" ? { apiCode, errorCode } : { apiCode, errorRemark }
      );
      this.loading = false;
    },

    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handelSave();
        }
      });
    }
  },
  components: {}
};
</script>

<style lang="less">
.page-error-code-test {
  .page-title {
    margin-bottom: 40px;
  }
  .page-content {
    display: flex;
    .page-content__left {
      width: 460px;
      flex-shrink: 0;
      .handle-button {
        margin: 40px 0px;
      }
    }
    .page-content__right {
      flex-grow: 1;
      margin-left: 40px;
      .req-item {
        border: 1px solid #e8eaec;
        margin-bottom: 24px;
        header {
          background: #f8f8f9;
          line-height: 40px;
          border-bottom: 1px solid #e8eaec;
          padding: 0px 18px;
          font-weight: 500;
        }
        .req-item__content {
          min-height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          .error-list {
            padding: 16px 20px;
            width: 100%;

            .error-list__item {
              font-size: 14px;
              border-bottom: 1px solid @color-border-primary;
              padding-bottom: 12px;
              &:last-child {
                border-bottom: none;
              }
              div {
                display: flex;
                padding: 4px 0px;
                label {
                  width: 72px;
                  color: @color-font-primary;
                  text-align: right;
                }
                span {
                  color: @color-font-default;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
